/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useMemo, useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { useHistory, Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/tableGrid';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { selectedType, dispatchCellClick } from '../../Contract/store/actions';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ManufacturerContracts(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    childRef,
    data,
    cellHead,
    addEditReduxDataManufacturerTab,
    addEditManufacturerTabData,
    setGridApi,
    setColumnApi,
    onFilterChanged,
    setTotalResultCount,
    fullScreenView,
    totalResultCount,
    handleOnSubmit,
    disabledSaveCancelBtn,
    resetData,
  } = props;

  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const containerStyle = useMemo(() => ({ width: '100%', height: '80%' }), []);
  const [rowData, setRowData] = React.useState(data);
  const [columnDefs] = React.useState(cellHead);
  // set row data
  React.useEffect(() => {
    setRowData(data);
  }, [data]);
  // set export pdf data inot PDF format
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);
  // go to particular Contract action button handler function
  const handleGoToContract = (row) => {
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.selectedRowData = row?.contractSeqNum;
    searchContractState.selectedContractId = row?.contractSeqNum;
    searchContractState.rebateProgramCode = row?.rebateProgramCd;
    searchContractState.searchContractDate = row?.startDt ? row.startDt : null;
    redirectURLLink('/createContract', 'Maintain Contract', history, dispatch);
  };
  // ag-grid frame work component
  const frameworkComponents = {
    StartDate: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className="tdCell icon-btn-group">
            <span className="td-date-range">
              {cellInfo.value}
              {'   '} <SVGComponent iconName="Icon_date-range" />
            </span>
          </div>
        );
      }
      return null;
    },
    EndDate: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className="tdCell icon-btn-group">
            <span className="td-date-range">
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName="Icon_date-range" />
            </span>
          </div>
        );
      }
      return null;
    },
    CheckBox: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox frr-display-hidden-checkbox-label">
            <FormControlLabel
              label="Coverage Gap Indecator Checkbox"
              control={<Checkbox color="primary" />}
              checked={cellInfo.value}
              value={cellInfo.value}
              disabled
            />
          </div>
        </>
      );
    },
    contractNameRender: (cellInfo) => {
      const name = cellInfo.data.contractName;
      if (name && name.length > 24) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="name-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    contractCodeRender: (cellInfo) => {
      return (
        <Link
          to="#"
          role="button"
          onClick={() => {
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              disabledSaveCancelBtn: disabledSaveCancelBtn,
            });
            handleGoToContract(cellInfo?.data);
          }}
        >
          {cellInfo && cellInfo.data.contractSeqNum}
        </Link>
      );
    },
  };
  return (
    <>
      <div data-testid="mfg-contract">
        <div style={containerStyle}>
          <div className="clearfix" />
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGrid
              onGridReady={onGridReady}
              ref={childRef}
              gridHeight={fullScreenView ? '70vh' : 400}
              rowData={rowData?.length > 0 ? rowData : []}
              columnDefs={columnDefs}
              frameworkComponents={frameworkComponents}
              onFilterChanged={onFilterChanged}
              data-testid="onEditingStopped"
              fileName="Manufacturer-Contracts"
              setTotal={setTotalResultCount}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
            />
          </div>
        </div>
      </div>
      <div className="tab-header tab-total-results">
        <p className="total-results" tabIndex="0">
          Total Results:<b>{totalResultCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
    </>
  );
}
